import { call, put, takeLatest, select } from 'redux-saga/effects'
import { handleApiErrors } from '../../lib/api-errors'
import axiosApi from '../../views/client/axiosClient'

import * as Constants from './constants'
import * as brActions from './actions'
const getNguoiDungRoleState = state => state.nguoiDungRole;

function handleRequest(request) {
  return request
    .then(handleApiErrors)
    .then(function (response) {
      return response.data;
    })
    .then(json => json)
    .catch((error) => { throw error })
}

function listRequestApi(formData) {
  const request = axiosApi().post(
    Constants.NGUOIDUNG_ROLE_LIST_API,
    formData
  )

  return handleRequest(request);
}

function detailRequestApi(formData) {
  const request = axiosApi().post(
    Constants.NGUOIDUNG_ROLE_DETAIL_API,
    formData
  )

  return handleRequest(request);
}

function nguoiDungRoleUpdateRequestApi(formData) {
  const request = axiosApi().post(
    Constants.NGUOIDUNG_ROLE_UPDATE_API,
    formData
  )

  return handleRequest(request);
}

function* nguoiDungRoleListRequestFlow() {
  const nguoiDungRole = yield select(getNguoiDungRoleState);
  try {
    // grab the client from our action
    const results = yield call(listRequestApi, nguoiDungRole.formData)

    // dispatch the action with our widgets!
    yield put(brActions.nguoiDungRoleListSuccess(results.data))

  } catch (error) {
    yield put(brActions.nguoiDungRoleListError(error))
  }
}

function* nguoiDungRoleDetailRequestFlow() {
  const nguoiDungRole = yield select(getNguoiDungRoleState);
  try {
    // grab the client from our action
    const results = yield call(detailRequestApi, nguoiDungRole.formData)

    // dispatch the action with our widgets!
    yield put(brActions.nguoiDungRoleDetailSuccess(results.data))

  } catch (error) {
    yield put(brActions.nguoiDungRoleDetailError(error))
  }
}

function* nguoiDungRoleUpdateRequestFlow() {
  const nguoiDungRole = yield select(getNguoiDungRoleState);
  try {
    // grab the client from our action
    const result = yield call(nguoiDungRoleUpdateRequestApi, nguoiDungRole.formData)

    // dispatch the action with our widgets!
    yield put(brActions.nguoiDungRoleUpdateSuccess(result));
    if (typeof callback == 'function') {
      nguoiDungRole.callback(results);
    }
  } catch (error) {
    yield put(brActions.nguoiDungRoleUpdateError(error))
  }
}

function* nguoiDungRoleWatcher() {
  yield [
    takeLatest(Constants.NGUOIDUNG_ROLE_LIST_REQUESTING, nguoiDungRoleListRequestFlow),
    takeLatest(Constants.NGUOIDUNG_ROLE_DETAIL_REQUESTING, nguoiDungRoleDetailRequestFlow),
    takeLatest(Constants.NGUOIDUNG_ROLE_UPDATE_REQUESTING, nguoiDungRoleUpdateRequestFlow),
  ]
}

export default nguoiDungRoleWatcher



// WEBPACK FOOTER //
// ./src/views/NguoiDungRole/sagas.js